import * as React from "react"
import { Box } from "@mui/material"

import { SECONDARY_SIDEBAR_WIDTH } from "data/sidebars"

export default function SecondarySidebarBase({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        maxHeight: "100vh",
        width: "100%",
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          displayPrint: "none",
          position: "fixed",
          flexDirection: "column",
          height: "100%",
          maxHeight: "100vh",
          width: "100%",
          maxWidth: SECONDARY_SIDEBAR_WIDTH,
          bgcolor: "gray.50",
          borderRight: 1,
          borderColor: "gray.200",
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
